import { useNavigate } from "react-router-dom";
import {
  useMyProperties,
  useMyPropertiesCount,
} from "@/_actions/propertiesActions";
import { usePlan } from "@/_actions/authActions";
import PropertyTable from "../properties/PropertyTable";
import Pagination from "@/components/navigation/Pagination";
import { order } from "@/constants/properties/filters";

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { propertiesParamsAtom } from "@/_actions/propertiesActions";
import { useAtom } from "jotai";
import usePlanStore from "@/stores/planStore";
import Filters from "./filters";
import AccountStatsBar from "@/components/Properties/AccountStatsBar";
import { Button } from "@/components/ui/button";
import { Plus, ChevronDown } from "lucide-react";
import { Label } from "@/components/ui/label";

export default function Properties() {
  const [params, setParams] = useAtom(propertiesParamsAtom);
  const {
    data: myProperties,
    mutate: mutateMyProperties,
    isLoading: isLoading,
  } = useMyProperties(params);
  const { data: allPropertiesCount, mutate: mutateAllProperties } =
    useMyPropertiesCount();
  const { data: planData } = usePlan();

  const { canPublish } = usePlanStore((state) => state);

  const r = myProperties?.results || [];
  const navigate = useNavigate();

  const publishedCount = allPropertiesCount?.published_total;

  return (
    <div className="space-y-2 py-2 mb-10 sm:mb-0">
      {/* Account Stats Bar */}
      <AccountStatsBar
        plan={planData?.plan}
        contract={planData?.contract}
        publishedCount={publishedCount}
        totalPublish={allPropertiesCount?.limit_properties_plan}
        outstandingCount={allPropertiesCount?.featured_properties_count}
        totalFeatured={allPropertiesCount?.limit_featured_plan}
      />

      {/* Create Property Button Desktop */}
      <div className="hidden items-center justify-start sm:flex">
        <Button
          onClick={() => navigate("/properties/create")}
          className="gap-2"
          disabled={!canPublish}
        >
          <Plus className="h-4 w-4" />
          Crear Propiedad
        </Button>
      </div>

      {/* Filters */}
      <div className="bg-white rounded-xl border border-zinc-200 p-4 shadow-sm">
        <Filters />
      </div>

      {/* Property Table */}
      <div className="flex justify-between items-center">
        <Label className="w-full">Mi inventario de propiedades</Label>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="w-[180px] justify-between">
              Ordenar
              <ChevronDown className="ml-2 h-4 w-4 opacity-50" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-[180px]">
            <DropdownMenuLabel>Ordenar por</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {order.map((option) => (
              <DropdownMenuCheckboxItem
                key={option.id}
                checked={params.ordering === option.id}
                onCheckedChange={(checked) => {
                  setParams({
                    ...params,
                    ordering: checked ? option.id : "",
                  });
                }}
              >
                {option.name}
              </DropdownMenuCheckboxItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className="bg-white rounded-xl border border-zinc-200 p-2 shadow-sm">
        <PropertyTable
          properties={r}
          mutateData={() => {
            mutateMyProperties();
            mutateAllProperties();
          }}
          publishedProperties={publishedCount}
          canPublish={canPublish}
          isLoading={isLoading}
          plan={planData?.plan}
          outstandingCount={allPropertiesCount?.featured_properties_count}
        />
      </div>

      {/* Pagination */}
      <Pagination
        total={myProperties?.count}
        type={"Propiedad"}
        current={params.page}
        next={myProperties?.next}
        previous={myProperties?.previous}
        pageSize={10}
        onPageChange={(page) => setParams((prev) => ({ ...prev, page }))}
      />
      <div className="fixed bottom-3 left-2 right-2 z-50 sm:hidden">
        <Button
          onClick={() => navigate("/properties/create")}
          className="h-12 w-full gap-2 bg-black shadow-lg hover:bg-zinc-800"
          disabled={!canPublish}
        >
          <Plus className="h-4 w-4" />
          Crear Propiedad
        </Button>
      </div>
    </div>
  );
}
